import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraAvatar } from '../ensigns/avatar';
import { SpecraIconTile } from '../ensigns/icon-tile';
import { SpecraText } from '../ensigns/typography';
/** Primary identity cell shared by people, companies, programs, and records. */ export function SpecraEntityCell({ avatarName, description, icon, title, trailing }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex min-w-0 items-center gap-2.5",
        children: [
            avatarName ? /*#__PURE__*/ _jsx(SpecraAvatar, {
                name: avatarName,
                size: "sm"
            }) : null,
            !avatarName && icon ? /*#__PURE__*/ _jsx(SpecraIconTile, {
                children: icon
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block truncate font-medium",
                        size: "caption",
                        children: title
                    }),
                    description ? /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block truncate",
                        size: "micro",
                        tone: "muted",
                        children: description
                    }) : null
                ]
            }),
            trailing
        ]
    });
}
